import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class BsVariantBasedIngredients extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  /**
   * Updates the content when the variant changes.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateContent = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newContent = event.detail.data.html.querySelector(
      `bs-variant-based-ingredients[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newContent) return;

    morph(this, newContent, { childrenOnly: true });
  };
}

if (!customElements.get('bs-variant-based-ingredients')) {
  customElements.define('bs-variant-based-ingredients', BsVariantBasedIngredients);
}
